"use client";

/**
 * Backwards-compatible wrapper.
 * Prefer `useMediaAssetRemove` from `@/features/media/hooks`.
 */

import { EntryType, MediaGroup } from "@/openapi/generated/models";
import { useMediaAssetRemove } from "@/features/media/hooks";

export const useTenantLogoRemove = (
  toast: ReturnType<typeof import("@/components/feedback").useToast>,
) => {
  const { mutateAsync, isPending, isError, isSuccess } = useMediaAssetRemove(toast);

  return {
    mutateAsync: (request: { tenantId: number; mediaId: number }) =>
      mutateAsync({
        tenantId: request.tenantId,
        ownerType: EntryType.Tenant,
        ownerId: request.tenantId,
        mediaGroup: MediaGroup.Logo,
        mediaId: request.mediaId,
      }),
    isPending,
    isError,
    isSuccess,
  };
};

